import { routes } from "routes/routes";

import { ReactComponent as ProfileIcon } from "assets/images/sideMenu/profile-icon.svg";
import { ReactComponent as SubsIcon } from "assets/images/sideMenu/subscriptions-icon.svg";

import { MenuItemI } from "./UserMenuItem";

export const userMenuItems: MenuItemI[] = [
  { route: routes.profile, icon: ProfileIcon, name: "Мій профіль" },
  { route: routes.subscription, icon: SubsIcon, name: "Мій тариф" },
];
